'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaFormController = function () {

  /*@ngInject*/
  function MediaFormController(Upload, Media, media, $state, Slug, marked, $sce) {
    _classCallCheck(this, MediaFormController);

    this.errors = {
      saveMedia: undefined,
      other: undefined
    };
    this.message = '';
    this.submitted = false;
    this.today = new Date();
    this.year = new Date().getFullYear();
    this.yearsToList = 2;
    this.years = [];
    this.sites = ['Ferries', 'Water Taxi', 'Freight'];
    this.tags = ['Service Medias', 'Weather', 'Medias', 'News', 'Season Parking', 'Events'];

    this.$sce = $sce;
    this.$marked = marked;
    this._$state = $state;
    this._Media = Media;
    this.$Uploader = Upload;
    this.$Slug = Slug;

    this.loading = false;

    this.renderedHTML = '';

    this.mission = null;

    if (!media) {
      this.setMedia();
    } else {
      this.data = media;
      if (this.data.publishDate) {
        this.data.publishDate = new Date(this.data.publishDate);
      }
    }

    if (this._$state.current.name == 'media.edit') {
      this.mission = 'edit';
      this.pageTitle = 'Edit Media';
    } else {
      this.mission = 'new';
      this.pageTitle = 'Create New Media';
    }
  }

  _createClass(MediaFormController, [{
    key: 'slugify',
    value: function slugify(input) {
      return this.$Slug.slugify(input);
    }
  }, {
    key: 'deleteFile',
    value: function deleteFile() {
      this.data.file = null;
      this.data.url = null;
      this.data.type = null;
      this.data.size = null;
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus() {
      if (this.data.status == 'Live') {
        this.data.publishDate = new Date();
      }
      if (this.data.status == 'Draft') {
        this.data.publishDate = null;
        this.data.publishTime = null;
      }
    }
  }, {
    key: 'upload',
    value: function upload(file) {
      var _this = this;

      this.uploading = false;
      console.log(file);

      this.$Uploader.upload({
        url: '/api/media/upload',
        fields: {
          test: 'thisisatest'
        },
        file: file
      }).progress(function (evt) {
        _this.uploading = true;

        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total, 10);
        _this.percentageLoaded = progressPercentage;
        console.log('progress: ' + progressPercentage + '% ' + evt.config.file.name);
      }).success(function (data) {
        _this.data.url = data.link;
        _this.data.type = data.type;
        _this.data.size = data.size;

        _this.uploading = false;
        console.log(data);
      });
    }
  }, {
    key: 'setMedia',
    value: function setMedia() {
      this.data = {
        title: '',
        icon: '',
        slug: '',
        excerpt: '',
        content: '',
        level: 'Normal',
        location: '',
        url: '',
        file: null,
        frontPage: false,
        sites: [],
        tags: [],
        email: {
          send: false,
          sent: false,
          date: ''
        },
        publishDate: '',
        publishTime: '',
        status: 'Draft'
      };
    }
  }, {
    key: 'zeroPad',
    value: function zeroPad(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join('0') + num;
    }
  }, {
    key: 'saveMedia',
    value: function saveMedia(form) {
      var _this2 = this;

      this.submitted = true;
      console.log(form);
      if (form.$valid) {
        this.loading = true;
        this._Media.save(this.data).then(function (res) {
          _this2.loading = false;
          console.log('Result', res);
          _this2._$state.go('media.list');
        }).catch(function (err) {
          _this2.loading = false;
          console.log('Error', err);
          _this2.error.saveMedia = err.data.message;
        });
      }
    }
  }]);

  return MediaFormController;
}();

exports.default = MediaFormController;


// WEBPACK FOOTER //
// ./client/app/media/form/form.controller.js